import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import './style.scss';

interface itemsInterface {
  name: string;
  url: string;
  icon: any;
}

interface PropsInterface {
  items: itemsInterface[];
  activeIndex: number;
}

const NavBar = ({ items, activeIndex }: PropsInterface) => {
  return (
    <div className='v-navbar'>
      <div className='v-nav'>
        {
          items.map(({ url, name, icon }, index) => {
            return(
              <Link to={url} key={name} className={'v-item' + (activeIndex === index ? ' active' : '')}>
                <FontAwesomeIcon icon={icon} />{name}
              </Link>
            )
          })
        }
      </div>
    </div>
  );
}

export default NavBar;